module.exports = __webpack_public_path__ + "img/course3.28867438.png";